import React, { Fragment, useEffect, useState } from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Divider, Grid, InputAdornment, TextField } from "@mui/material";

import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { useAuth } from "../../../../../hooks";

const SearchBar = ({
  selected,
  placeholder,
  handleDeleteQuickTale,
  handleDuplicateQuickTales,
  handleUpdateQuickTaleStatus,
  handleUpdateQuickTaleApprovalStatus,
  handleUpdateQuickTaleReportedStatus,
  handleSearch,
}) => {
  const { currentUser } = useAuth();
  const [statusOptions, setStatusOptions] = useState(false);
  const [whoCanListenOptions, setWhoCanListenOptions] = useState(false);
  const [reportedStatusOptions, setReportedStatusOptions] = useState(false);

  const anyActive = statusOptions || whoCanListenOptions || reportedStatusOptions;

  useEffect(() => {
    if (selected && selected.length < 1) {
      setStatusOptions(false);
      setWhoCanListenOptions(false);
      setReportedStatusOptions(false);
    }
  }, [selected]);

  const fadeStyle = (isActive) => ({
    opacity: anyActive && !isActive ? 0.3 : 1,
    transition: "opacity 0.2s ease",
  });

  return (
    <Grid container alignItems={"center"}>
      <TextField
        variant="outlined"
        placeholder={placeholder ? placeholder : "Search name, phone, email"}
        onChange={
          handleSearch ? (e) => handleSearch(e) : () => console.log("search")
        }
        InputProps={{
          sx: { ...searchTextfieldStyles },
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon />
            </InputAdornment>
          ),
        }}
      />
      {selected && selected.length > 0 && (
        <Fragment>
          <span style={selectedItemsStyles}>{selected.length} selected</span>
          {currentUser?.role === "moderator" ? undefined : (
            <Fragment>
              <TrendingFlatIcon fontSize="large" style={{ color: "#242424" }} />
              {/* <span
                style={statusTextSTyles}
                onClick={() => handleDeleteQuickTale()}
              >
                Delete
              </span>
              <Divider
                orientation="vertical"
                sx={{ height: 25, borderColor: "#000" }}
              /> */}
            </Fragment>
          )}

          {currentUser?.role === "moderator" ? undefined : (
            <Fragment>
              <span
                style={{ ...statusTextSTyles, ...fadeStyle(false) }}
                onClick={() => {
                  setStatusOptions(false);
                  setWhoCanListenOptions(false);
                  setReportedStatusOptions(false);
                  handleDuplicateQuickTales && handleDuplicateQuickTales();
                }}
              >
                Duplicate
              </span>
              <Divider
                orientation="vertical"
                sx={{ height: 25, borderColor: "#000", ...fadeStyle(false) }}
              />
            </Fragment>
          )}
          {currentUser?.role === "moderator" ? undefined : (
            <span
              style={{
                ...statusTextSTyles,
                color: statusOptions ? "#9447AF" : "#00A7CD",
                ...fadeStyle(statusOptions),
              }}
              onClick={() => {
                setStatusOptions((prev) => !prev);
                setWhoCanListenOptions(false);
                setReportedStatusOptions(false);
              }}
            >
              Status
            </span>
          )}
          {statusOptions && (
            <Fragment>
              <TrendingFlatIcon
                fontSize="medium"
                style={{ color: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleStatus(true)}
              >
                Draft
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleStatus(false)}
              >
                Finished
              </span>
            </Fragment>
          )}
          {currentUser?.role === "moderator" ? undefined : (
            <Fragment>
              <Divider
                orientation="vertical"
                sx={{ height: 25, borderColor: "#000", ...fadeStyle(whoCanListenOptions) }}
              />
              <span
                style={{
                  ...statusTextSTyles,
                  color: whoCanListenOptions ? "#9447AF" : "#00A7CD",
                  ...fadeStyle(whoCanListenOptions),
                }}
                onClick={() => {
                  setWhoCanListenOptions((prev) => !prev);
                  setStatusOptions(false);
                  setReportedStatusOptions(false);
                }}
              >
                Who Can Listen
              </span>
            </Fragment>
          )}
          {whoCanListenOptions && (
            <Fragment>
              <TrendingFlatIcon
                fontSize="medium"
                style={{ color: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleApprovalStatus("public")}
              >
                Public
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleApprovalStatus("private")}
              >
                Private
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleApprovalStatus("unlisted")}
              >
                Unlisted
              </span>
              {/* <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleApprovalStatus("draft")}
              >
                Draft
              </span> */}
            </Fragment>
          )}
          {currentUser?.role === "moderator" ? undefined : (
            <Fragment>
              <Divider
                orientation="vertical"
                sx={{ height: 25, borderColor: "#000", ...fadeStyle(reportedStatusOptions) }}
              />
              <span
                style={{
                  ...statusTextSTyles,
                  color: reportedStatusOptions ? "#9447AF" : "#00A7CD",
                  ...fadeStyle(reportedStatusOptions),
                }}
                onClick={() => {
                  setReportedStatusOptions((prev) => !prev);
                  setWhoCanListenOptions(false);
                  setStatusOptions(false);
                }}
              >
                Reported Status
              </span>
            </Fragment>
          )}
          {reportedStatusOptions && (
            <Fragment>
              <TrendingFlatIcon
                fontSize="medium"
                style={{ color: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleReportedStatus("flagged")}
              >
                Flagged
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleReportedStatus("in review")}
              >
                In Review
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleReportedStatus("pending")}
              >
                Pending
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleReportedStatus("resolved")}
              >
                Resolved
              </span>
            </Fragment>
          )}
        </Fragment>
      )}
    </Grid>
  );
};

export default SearchBar;

const searchTextfieldStyles = {
  height: 40,
  border: "none",
  borderColor: "#7676801F",
  borderRadius: 5,
  width: 270,
  background: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  paddingLeft: 1,
  paddingRight: 2,
  fontFamily: "Avenir Book, sans-serif",
};

const selectedItemsStyles = {
  color: "#020303",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};

const statusTextSTyles = {
  color: "#00A7CD",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: "Avenir Book, sans-serif",
};
